// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consulting-expertise-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 140px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.consulting-expertise-image {
  position: relative;
  width: 48%;
  order: 1;
  margin-top: -10px;
}

.services-image {
  width: 220%;
  height: auto;
  border-radius: 8px;
}

.consulting-expertise-text {
  margin-top: -90px;
  width: 90%;
  margin-left: 60px;
  order: 2;
}

.consulting-expertise-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 10px;
}

.consulting-expertise-text p {
  font-size: 1em;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

.consulting-expertise-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.consulting-expertise-button:hover {
  background-color: #009624;
}

@media (max-width: 768px) {
  .consulting-expertise-container {
    flex-direction: column;
    align-items: center;
    text-align: left;
    gap: 20px;
  }

  .consulting-expertise-text {
    width: 280%;
    margin-left: -20px;
    margin-top: -50px;
    order: 2;
  }

  .consulting-expertise-text h1 {
    width: 130%;
    margin-left: 0px;
  }

  .consulting-expertise-image {
    width: 300%;
    margin-top: 20px;
    order: 1;
  }

  .services-list li {
    width: 100%;
  }
}
@media (min-width: 1380px) and (max-width: 1919px) {
  .consulting-expertise-container {
    padding: 160px;
  }

  .consulting-expertise-text {
    margin-top: -80px;
    margin-right: 40px;
    width: 55%;
  }

  .consulting-expertise-image {
    width: 32%;
  }

  .services-list li {
    width: 44%;
  }
}
@media (min-width: 1920px) and (max-width: 1920px) {
  .consulting-expertise-container {
    padding: 100px;
  }

  .consulting-expertise-text {
    width: 58%;
  }

  .consulting-expertise-image {
    width: 38%;
  }

  .services-list li {
    width: 40%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ConsultingExpertise/ConsultingExpertise.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".consulting-expertise-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 140px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.consulting-expertise-image {\n  position: relative;\n  width: 48%;\n  order: 1;\n  margin-top: -10px;\n}\n\n.services-image {\n  width: 220%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.consulting-expertise-text {\n  margin-top: -90px;\n  width: 90%;\n  margin-left: 60px;\n  order: 2;\n}\n\n.consulting-expertise-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.consulting-expertise-text p {\n  font-size: 1em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n.consulting-expertise-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.consulting-expertise-button:hover {\n  background-color: #009624;\n}\n\n@media (max-width: 768px) {\n  .consulting-expertise-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    gap: 20px;\n  }\n\n  .consulting-expertise-text {\n    width: 280%;\n    margin-left: -20px;\n    margin-top: -50px;\n    order: 2;\n  }\n\n  .consulting-expertise-text h1 {\n    width: 130%;\n    margin-left: 0px;\n  }\n\n  .consulting-expertise-image {\n    width: 300%;\n    margin-top: 20px;\n    order: 1;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n}\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .consulting-expertise-container {\n    padding: 160px;\n  }\n\n  .consulting-expertise-text {\n    margin-top: -80px;\n    margin-right: 40px;\n    width: 55%;\n  }\n\n  .consulting-expertise-image {\n    width: 32%;\n  }\n\n  .services-list li {\n    width: 44%;\n  }\n}\n@media (min-width: 1920px) and (max-width: 1920px) {\n  .consulting-expertise-container {\n    padding: 100px;\n  }\n\n  .consulting-expertise-text {\n    width: 58%;\n  }\n\n  .consulting-expertise-image {\n    width: 38%;\n  }\n\n  .services-list li {\n    width: 40%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
